import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=8eb22a1e&"
import script from "./IconDelete.vue?vue&type=script&lang=js&"
export * from "./IconDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eb22a1e')) {
      api.createRecord('8eb22a1e', component.options)
    } else {
      api.reload('8eb22a1e', component.options)
    }
    module.hot.accept("./IconDelete.vue?vue&type=template&id=8eb22a1e&", function () {
      api.rerender('8eb22a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDelete.vue"
export default component.exports